type CLOUD_ENV = 'production' | 'staging' | 'development' | 'local';

function getIdentityActionUrl(action: 'login' | 'logout', env: CLOUD_ENV) {
	const identityDomain = getIdentityDomain(env);
	const redirectUrl = getRedirectUrl(env);
	return `https://${identityDomain}/${action}?continue=${encodeURIComponent(redirectUrl)}`;
}

function getIdentityDomain(env: CLOUD_ENV) {
	if (env !== 'production') {
		return 'id.stg.internal.atlassian.com';
	}

	return 'id.atlassian.com';
}

export function getIdentityLoginUrl(env: CLOUD_ENV = getEnv()): string {
	return getIdentityActionUrl('login', env);
}

export function getIdentityLogoutUrl(env: CLOUD_ENV = getEnv()): string {
	return getIdentityActionUrl('logout', env);
}

export function isStagingDomain(): boolean {
	const env = getEnv();
	return env === 'staging';
}

export function isDevOrStagingDomain(): boolean {
	const env = getEnv();
	return ['staging', 'development', 'local'].includes(env);
}

export function getRedirectUrl(env: CLOUD_ENV = getEnv()): string {
	const currentUrl = globalThis.location.href;

	if (env === 'local') {
		// Redirect via the local CST proxy.
		return `${globalThis.origin}/_pillar/auth/success?redirect=${encodeURIComponent(currentUrl)}`;
	}

	return currentUrl;
}

export function getEnv(): CLOUD_ENV {
	return (process.env.CLOUD_ENV as CLOUD_ENV) ?? 'local';
}
